import { render, staticRenderFns } from "./account-details.vue?vue&type=template&id=4d79dfa6&scoped=true&"
import script from "./account-details.vue?vue&type=script&lang=js&"
export * from "./account-details.vue?vue&type=script&lang=js&"
import style0 from "./account-details.vue?vue&type=style&index=0&id=4d79dfa6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d79dfa6",
  null
  
)

export default component.exports